import { ContentSchedule } from "entities/contentSchedule/types";
import { PageModuleStatus } from "entities/pages/types";
import { chipColorsMap, chipTextMap } from "modules/contentSchedule/utils";
import StatusBadge, {
  StatusBadgeBaseProps,
} from "shared/components/StatusBadge";

type ContentStatusItem = StatusBadgeBaseProps & {
  brandId: string;
  pageId: string;
};

type ContentStatusParams = {
  brandId: string;
  pageId: string;
};

const ContentStatusBadge = ({
  module,
  handleStatus,
  readOnly,
}: Readonly<{
  module: ContentSchedule;
  handleStatus?: (params: {
    brandId: string;
    pageId: string;
    moduleId: string;
    status: PageModuleStatus;
  }) => void;
  readOnly?: boolean;
}>) => {
  const statusItem: ContentStatusItem = {
    id: module.id,
    status: module.status,
    title: chipTextMap[module.status],
    color: chipColorsMap[module.status],
    brandId: module.brandId,
    pageId: module.pageId,
    readOnly,
  };

  const handleStatusChange = (
    params: {
      id: string;
      status: PageModuleStatus;
    } & ContentStatusParams,
  ) => {
    if (handleStatus) {
      handleStatus({
        brandId: params.brandId,
        pageId: params.pageId,
        moduleId: params.id,
        status: params.status,
      });
    }
  };

  return (
    <StatusBadge<ContentStatusItem, ContentStatusParams>
      item={statusItem}
      handleStatus={handleStatusChange}
      readOnly={readOnly}
      additionalParams={{
        brandId: module.brandId,
        pageId: module.pageId,
      }}
    />
  );
};

export default ContentStatusBadge;
